import useTableManagementStorage from "../stores/useTableManamentStore";
import { getOrCreateSessionId } from "./Common";

export const getLayoutFloorsArrAsObj = (floors) => {
  if (floors.length === 0) {
    return {};
  }

  const layoutFloors = {};

  floors.forEach((item) => {
    layoutFloors[item.id] = item;
  });

  return layoutFloors;
};

export const updateGuestNumber = (guestNumber) => {
  const { setIdWiseGuestNumber } = useTableManagementStorage.getState();
  const sessionId = getOrCreateSessionId();
  setIdWiseGuestNumber(sessionId, guestNumber);

  console.log("-----updateGuestNumber------", { sessionId, guestNumber });
};

export const updateFloorTabActiveKey = (floorId) => {
  const { setFloorTabActiveKey } = useTableManagementStorage.getState();
  setFloorTabActiveKey(floorId);
};

export const updateFloorTabActiveKeyOnInit = (floors) => {
  if (floors.length === 0) {
    updateFloorTabActiveKey("1");
  }
  updateFloorTabActiveKey(floors[0].id);
};

export const setFloorPlanModalActionMode = (floorPlanModalActionMode) => {
  const { setModalActionMode } = useTableManagementStorage.getState();
  setModalActionMode(floorPlanModalActionMode);
};

export const getSelectedTablesFromStore = () => {
  const { getIdWiseSelectedTablesOrg } = useTableManagementStorage.getState();
  const sessionId = getOrCreateSessionId();

  return getIdWiseSelectedTablesOrg(sessionId);
};

export function addSelectedTablesInStore(tableInfo, isAlsoOrg = false) {
  const { addIdWiseSelectedTables, addIdWiseSelectedTablesOrg } = useTableManagementStorage.getState();

  const sessionId = getOrCreateSessionId();

  addIdWiseSelectedTables(sessionId, tableInfo);

  if (isAlsoOrg) {
    addIdWiseSelectedTablesOrg(sessionId, [tableInfo]);
  }
}

export function replaceSelectedTablesInStore(tableInfoArr, isAlsoOrg = false) {
  const { replaceIdWiseSelectedTables, addIdWiseSelectedTablesOrg } = useTableManagementStorage.getState();

  const sessionId = getOrCreateSessionId();

  replaceIdWiseSelectedTables(sessionId, tableInfoArr);

  if (isAlsoOrg) {
    addIdWiseSelectedTablesOrg(sessionId, tableInfoArr);
  }
}

export function resetNewlySelectedTableInStore() {
  const orgTables = getSelectedTablesFromStore();
  replaceSelectedTablesInStore(orgTables);
}

export function updateLayoutFloorsFromSocket(socketData) {
  const { updateLayoutFloors, setLayoutSummary } = useTableManagementStorage.getState();
  setLayoutSummary(socketData.statusSummary);

  const floorMap = {};

  socketData.floorTables.forEach(({ floorId, id, ...rest }) => {
    if (!floorMap[floorId]) floorMap[floorId] = [];
    floorMap[floorId].push({ id, ...rest });
  });

  Object.entries(floorMap).forEach(([floorId, updates]) => {
    updateLayoutFloors(floorId, updates);
  });
}

/**
 * actionType ADD_MORE_TABLE, MERGE_ORDER, TRANSFER_ORDER
 *
 * @param {*} notifier
 * @param {*} tableInfo
 */
export const handleMultiActionsOnTableModal = (notifier, tableInfo, selectedTable) => {
  const { modalActionMode } = useTableManagementStorage.getState();

  console.log("======handleMultiActionsOnTableModal=======", { modalActionMode, tableInfo, selectedTable });

  if (["ADD_MORE_TABLE", "TRANSFER_ORDER"].includes(modalActionMode)) {
    addSelectedTablesInStore(tableInfo, false);
    return;
  }

  if (modalActionMode === "MERGE_ORDER" && selectedTable.activeOrders.length > 1) {
    notifier("Sorry. This table has multiple order");
    return;
  } else if (modalActionMode === "MERGE_ORDER" && selectedTable.activeOrders.length === 0) {
    notifier("Sorry. This table has no order");
    return;
  } else if (modalActionMode === "MERGE_ORDER") {
    const orderId = selectedTable.activeOrders[0].orderId; // it okay as here only one order will be present
    const orgTables = getSelectedTablesFromStore();
    const isExist = orgTables.some((item) => item.orderId === orderId);

    if (!isExist) {
      addSelectedTablesInStore({ ...tableInfo, orderId: selectedTable.activeOrders[0].orderId }, false);
    }
  }
};

export const updateTableManagementStore = async (floors, statusSummary) => {
  if (floors.length === 0) {
    return;
  }
  
  const { setLayoutFloors, setLayoutSummary } = useTableManagementStorage.getState();
  updateFloorTabActiveKeyOnInit(floors);
  setLayoutFloors(getLayoutFloorsArrAsObj(floors));
  setLayoutSummary(statusSummary);
};
